import type { RefObject } from "react";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { templateLocaleNamespace } from "./UpdateTemplateContent";

export const CreateTemplateContent = ({
  nameInputRef,
}: {
  nameInputRef: RefObject<HTMLInputElement>;
}) => (
  <Form.Item
    name="name"
    translationRoot={templateLocaleNamespace}
    label={t([templateLocaleNamespace, "template_name"])}
    hideDescription
    hideBorder
    placeholder={t([templateLocaleNamespace, "template_name_placeholder"])}
  >
    <Form.Input ref={nameInputRef} />
  </Form.Item>
);
